<template>
  <div class="stage-frame" ref="frame">
    <canvas ref="canvas"></canvas>
  </div>
</template>

<script>
export default {
  name: 'StageFrame',

  mounted() {
    this.$eventHub.$on('gameover', this.gameover);

    this.$game.init(this.$refs.frame, this.$refs.canvas);
  },

  methods: {
    gameover() {
      this.$game.gameover();
    },
  },
};
</script>

<style lang="scss" scoped>
.stage-frame {
  @extend %full;

  display: flex;
  align-items: center;
  justify-content: center;

  canvas {
    transform: scale(var(--rw));
  }
}
</style>
